import { useEffect } from 'react'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import { parseRunSlugFromPathname } from './parseRunSlugFromPathname'
import useTranslation from './useTranslation'

// Stored titles read "<Name> 3D Model", so strip the trailing "3D Model" before
// the seo template re-appends "3D model" — mirrors
// ThreeDStudioController#output_model_name.
const stripModelSuffix = (name) => {
  const trimmed = name.trim()
  return trimmed.replace(/\s*3d\s*model\s*$/i, '').trim() || trimmed
}

// Keeps document.title in sync on client-side navigation. The server renders
// the correct title per URL (ThreeDStudioController#studio_meta_title), but
// switching models inside the SPA only pushes history state, so without this
// the tab title goes stale until a full reload.
const usePageTitleSync = () => {
  const t = useTranslation()
  const location = useLocation()
  const pathname = location?.pathname ?? ''
  const modelName = useThreeDStudioStore(
    state => state.ui?.openedModel?.title ?? state.ui?.openedModel?.prompt ?? ''
  )

  useEffect(() => {
    if (modelName) {
      document.title = t('seo.outputTitle', { name: stripModelSuffix(modelName) })
      return
    }

    // A run URL whose model has not loaded yet: keep the current (server
    // rendered) title instead of flashing the index one mid-fetch.
    if (parseRunSlugFromPathname(pathname) != null) {
      return
    }

    const isGallery = pathname === '/ai-3d-model-generator/3d-models'
      || pathname === '/ai-3d-model-generator/3d-models/'
    document.title = t(isGallery ? 'seo.galleryTitle' : 'seo.indexTitle')
  }, [modelName, pathname, t])
}

export default usePageTitleSync
